module.exports = __webpack_public_path__ + "static/media/10.47b2215e.jpeg";